/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function InsightsIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path fillRule="evenodd" clipRule="evenodd" d="M37.482 8.41c.642.592.694 1.604.116 2.26l-14.087 16a1.55 1.55 0 0 1-1.122.53 1.55 1.55 0 0 1-1.148-.469l-5.937-6.068L4.672 31.53a1.54 1.54 0 0 1-2.214 0 1.625 1.625 0 0 1 0-2.262l11.74-12a1.54 1.54 0 0 1 2.213 0l5.877 6.007L35.271 8.53a1.54 1.54 0 0 1 2.21-.12"/>}
        </IconWrapper>);
}
